/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import PropTypes from 'prop-types';
import { scheduleItemTitleCss } from './index.styles';
import { dataContentTitleCss, dataContentValueCss } from '../index.styles';
import { SafePureComponent } from '../../../../utils/SafePureComponent';

class Schedule extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const { day, value } = props;
    return (
      <li>
        <span css={[dataContentTitleCss, scheduleItemTitleCss]}>
          <Text field={{ value: day }} />
        </span>
        <span css={dataContentValueCss}>
          <Text field={{ value: value }} />
        </span>
      </li>
    );
  }
}

Schedule.displayName = 'Schedule';

const defaultData = {
  day: '',
  value: '',
};

Schedule.defaultProps = defaultData;

Schedule.propTypes = {
  day: PropTypes.string,
  value: PropTypes.string,
};

export default Schedule;
